module.exports = __webpack_public_path__ + "static/media/chatgpt.c6ddaaaf.svg";